export default "__VITE_ASSET__Bkd37smE__"